import React, { useEffect } from 'react';
import './assets/scss/themes.scss';
import './assets/scss/theme-hydro.scss';
import './assets/scss/form-system.scss';
import './assets/scss/icon-system.scss';
import './assets/scss/responsive.scss';
import './assets/scss/a11y.scss';
import Routes from './Routes';
import { useSelector } from 'react-redux';
import { setAuthorization } from './helpers/api_helper';
import { ToastContainer } from 'react-toastify';
import ConfirmHost from './Components/Common/ConfirmHost';
import { startA11yEnhancer } from './utils/a11yEnhancer';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const token = useSelector(state => state.Login.user?.token);

  useEffect(() => {
    if (token) {
      setAuthorization(token);
    }
  }, [token]);

  // Adds the semantics legacy markup is missing (see utils/a11yEnhancer.js).
  useEffect(() => startA11yEnhancer(), []);

  return (
    <>
      <Routes />
      {/* The only toast container in the app. Fire toasts through utils/notify.js. */}
      <ToastContainer limit={1} />
      {/* Renders confirmAction() dialogs from utils/confirm.js. */}
      <ConfirmHost />
    </>
  );
}

export default App;

// import React from "react";
// import "./assets/scss/themes.scss";
// import Route from "./Routes";
// function App() {
//   return (
//     <React.Fragment>
//       <Route />
//     </React.Fragment>
//   );
// }
// export default App;

// import { AuthProvider } from "oidc-react";
// const oidcConfig = {
//   onSignIn: () => {
//     // Redirect?
//     navigate("/dashboard");
//   },
//   authority: "https://login-v3.qa.idaman.pertamina.com",
//   clientId: "8005b875-3ab3-40ec-a138-9ca27c67dbe1",
//   redirectUri: "http://localhost:9092/dashboard",
//   ClientSecret: "be8efdd3-e0b1-4e9e-96a7-c356d6335e30",
//   Scopes: "openid, profile, email",
// };
// function App() {
//   return (
//     <AuthProvider {...oidcConfig}>
//       <Route />
//     </AuthProvider>
//   );
// }
// export default App;
